// removed by extract-text-webpack-plugin
module.exports = {"MainContainer":"layout__MainContainer__18O7N","ButtonSection":"layout__ButtonSection__11hbB","Container":"layout__Container__3GVYF","FormBorder":"layout__FormBorder__11bih"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FormLayout/layout.css
// module id = 5
// module chunks = 0